import { render } from "./MarumiyaProducts.vue?vue&type=template&id=29c32efa&scoped=true"
import script from "./MarumiyaProducts.vue?vue&type=script&lang=ts"
export * from "./MarumiyaProducts.vue?vue&type=script&lang=ts"

import "./MarumiyaProducts.vue?vue&type=style&index=0&id=29c32efa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-29c32efa"

export default script